import React from 'react';
import { useTranslation  } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import Button from 'src/components/Button/Button';
import '../CancelTicket.scss';


function CancelRequest() {
  const { t } = useTranslation();
  const history = useHistory();

  const onClose = () => {
    if (location.hash?.length > 1) {
      history.replace(location.pathname);
    }
  };

  return (
    <div className="cancel-ticket__modal">
      <span className="cancel-ticket__text">{ t('modal.ticketCancelationRequest') }:</span>
      <h3 className="cancel-ticket__subtitle">{ t('modal.cancelRequested') }</h3>
      <Button
        type="button"
        text={ t('form.ok') }
        className="btn btn--cta cancel-ticket__btn modal-submit"
        onClick={ onClose }
      />
    </div>
  );
}

export default CancelRequest;
